import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import { EffectFade, Navigation, Pagination } from 'swiper/modules';
import { memo } from 'react';
import { useSelector } from 'react-redux';
import { LazyLoadImage } from 'react-lazy-load-image-component';

function SliderHome() {

  const {userBanner} = useSelector((state) => state.request);

  return (
    <>
      <Swiper
        spaceBetween={30}
        effect={'fade'}
        pagination={{
          clickable: true,
        }}
        navigation
        modules={[EffectFade, Navigation, Pagination]}
        className="mySwiper"
      >
        {userBanner.length > 0 && userBanner?.map((slider, index) => (
            <SwiperSlide key={index}>
            <LazyLoadImage
              className="h-full w-full object-cover"
              src={slider.photo_url}
              alt={`imag-${index}`}
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
            />
          </SwiperSlide>
          ))}
      </Swiper>
    </>
  );
}

export default memo(SliderHome);

